// extracted by mini-css-extract-plugin
module.exports = {"list":"LinkList-module--list--1dLQa","title":"LinkList-module--title--bzGd5"};